import React, { useState } from "react";
import close from "../../../../src/static/ic-close.svg";
import { withTranslation, Trans } from "react-i18next";

import Slide from "@material-ui/core/Slide";
import { connect } from "react-redux";
import { get_accessToken, get_billingEmail, get_LeftRight } from "../../../helper/UserData/userdate";
import { Api_Get_AcountInformation_AGW } from "../../../helper/api/ApiGateway";
import { ReactComponent as ChangePassword } from "../../../../src/static/Change-Password.svg";
import {ReactComponent as withdraw_email_document} from "../../../../src/static/IconProvider/withdraw/ic_email_document.svg";
import { Bussiness_change_password } from "../../../helper/api";
import IconProviderSvgModifier from "../../../design-system/lib/IconProviderSvgModifier";
import { SucceessFul_i18 } from "../../../helper/Notification/sendNotification";
import { httpCustomer } from "../../../service/api/axios";
import { Customer_Edit_AccountInformation_Action } from "../../../Redux/actions/actions";
import { snack } from "../../../helper/module/SnackbarUtilsConfigurator";

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showForm: false,
      currentPassword: "",
      newpassword: get_billingEmail() || "",
      Retypenewpassword: "",
    };
    this.saveChangePassword = this.saveChangePassword.bind(this)
  }

  handleShowForm() {
    this.setState({
      showForm: true,
    });
  }

  openOrderHistory = () => {
    this.setState({
      showForm: false,
    });
  };

  inputOnchange(key, val) {
    this.setState({
      [key]: val,
    });
  }

  saveChangePassword() {

       var bodyFormData = new FormData();
        bodyFormData.append("billingEmail", this.state.newpassword);
 
       this.props.dispatch(
         Customer_Edit_AccountInformation_Action(this.props.dispatch, bodyFormData, (data)=>{
          //call({ res, loading: false, error: false })
          snack.success(this.props.t("SucceessFul"))
         })
       );

          this.setState({
      showForm: false,
    });
     
  }

  render() {
    let canSave =
      String(this.state.newpassword) && validateEmail(this.state.newpassword) &&
      String(this.state.newpassword).length > 5;
    return (
      <>
        <div
          className={`PhoneNumberContainer ${this.state.numberNotRegistered && "PhoneNumberContainerError"
            }`}
          style={{ height: "32px", borderRadius: "8px", marginTop: "4px" ,marginBottom:"12px" }}
          onClick={() => this.handleShowForm()}
        >
          <span
            onClick={this.handleOpen}
            className={`langContainer`}
            style={{ paddingTop: "8px" }}
          >
            <div className="SignOutContainer">
              {/* <ChangePassword className="SignOut ChangePasswordicon" /> */}
              <IconProviderSvgModifier Icon={withdraw_email_document} size="20" style={{float:"inline-start" , width :"20px"}} className={"ChangePasswordicon"} />
              <span className="LogoutText">
                {" "}
                <Trans i18nKey={"Billingemail"}> </Trans>
              </span>
            </div>
          </span>
        </div>

        <Slide
          timeout={650}
          direction={get_LeftRight()}
          in={this.state.showForm}
          mountOnEnter
          unmountOnExit
        >
          <div className="OrderHistoryContainer">
            <div className="OrderListHeader">
              <img
                onClick={this.openOrderHistory}
                src={close}
                className="OrderListHeaderClose"
              />
              <span className="OrderListHeaderTitle">
                <Trans i18nKey={"Billingemail"}></Trans>
              </span>
            </div>

            <div className="SettingItemsContainerx2" style={{paddingTop :"0px"}}>
 
              <div
                className="firstnamelastnameContainer emailcontainer"
                style={{ height: "56px", marginTop: "10px" }}
              >
                <p className="LP_PhoneNumberLabel">
                  <Trans i18nKey={"Email Address"}> </Trans>{" "}
                </p>
                <div
                  className={`PhoneNumberContainer `}
                  style={{ height: "32px", borderRadius: "8px",
                      borderColor : canSave ? "": "#FF5E5E" }}
                >
                  <input
                    
                    type="email"
                    placeholder={this.props.t("Ex. example@example.com")}
                    className="emailinputregister"
                    value={this.state.newpassword}
                    onChange={(e) => {
                      this.inputOnchange("newpassword", e.target.value);
                    }}
                    style={{
                      marginTop: "5px",
                      fontSize: "12px",
                      fontWeight: "300"
                    }}
                  />
                </div>
              </div>
 
            </div>

            <div className="SettingFooter">
              <span
                style={{
                  backgroundImage: canSave && `linear-gradient(to top,${global.config.colors.primary}, ${global.config.colors.primaryLight})`,
                  color: canSave && global.config.colors.primaryText
                }}
                className={`SettingFooterButton ${!canSave && "DeactiveSettingFooterButton"
                  }`}
                onClick={canSave && this.saveChangePassword}
              >
                <Trans i18nKey={"Save"}></Trans>
              </span>
            </div>
          </div>
        </Slide>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  open: state.Settings.SettingsOpenDialoge,
});
const mapDispatchToProps = (dispatch) => ({
  dispatch: dispatch,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(App));


  export const validateEmail = (email) => {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  };